import React, { useRef, useState } from 'react'
import { styleClass } from '../utils/helpers'
import { categoryLabels } from '../data/translations'
import { sanitizeHtml } from '../utils/html'
import { downloadElementScreenshot } from '../utils/shareImage'

const ShareIcon = () => (
  <svg
    className="share-button-icon"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M4 12v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7" />
    <path d="M12 16V4" />
    <path d="m7 9 5-5 5 5" />
  </svg>
)

const Card = ({ item, language }) => {
  const cardRef = useRef(null)
  const [isSharing, setIsSharing] = useState(false)
  const name = language === 'EN' ? item.nameEN : item.name
  const descr = language === 'EN' ? item.descrEN : item.descr
  const category = categoryLabels[language][item.category]
  const shareLabel = language === 'EN' ? 'Share card image' : 'Поделиться изображением карты'

  const handleShare = async () => {
    if (isSharing) return

    setIsSharing(true)
    try {
      await downloadElementScreenshot({
        element: cardRef.current,
        filenameBase: name,
        type: 'card',
      })
    } catch (error) {
      console.error('Failed to create card image', error)
      alert(language === 'EN' ? 'Could not create the image.' : 'Не удалось создать изображение.')
    } finally {
      setIsSharing(false)
    }
  }

  return (
    <div className="card" ref={cardRef}>
      <button
        type="button"
        className="item-share-button"
        onClick={handleShare}
        aria-label={shareLabel}
        title={shareLabel}
        disabled={isSharing}
      >
        <ShareIcon />
      </button>

      <div className="card-image-wrapper">
        <img
          src={process.env.PUBLIC_URL + item.imgUrl}
          alt={name}
          className="card-image"
          loading="lazy"
        />
        <span className="round-btn-cost">{item.cost}</span>
        <span className="round-btn-power">{item.power}</span>
      </div>

      <div
        className={`card-category ${styleClass(categoryLabels.EN[item.category])}`}
      >
        {category}
      </div>

      <h3 className="card-name" dangerouslySetInnerHTML={{ __html: sanitizeHtml(name) }} />
      <div className="card-descr" dangerouslySetInnerHTML={{ __html: sanitizeHtml(descr) }} />
    </div>
  )
}

export default Card
